<script setup lang="ts">
    import { onMounted, reactive, ref, watch } from 'vue';
    import axios from 'axios';
    import { useRoute, useRouter } from 'vue-router';

    const router = useRouter();
    const route = useRoute();
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        id: "",
        libelle: "",
        type_aide: "FAQ"
    });
    const errors = reactive({
        libelle: "",
        type_aide: ""
    });

    onMounted(() => {
        const form_datas: any = route.meta.form_datas;
        if (form_datas?.categorie) {
            const item = form_datas.categorie as any;
            formData.id = item.id;
            formData.libelle = item.libelle;
            formData.type_aide = item.type_aide;
        }
    });

    watch(formData, (oldFormData, newFormData) => {
        validate();
    });

    function validate() {
        let isValid = true;

        errors.libelle = '';
        if (!formData.libelle) {
            errors.libelle ="La libelle est requise";
            isValid = false;
        }

        if (!formData.type_aide || ["FAQ", "TUTORIEL"].lastIndexOf(formData.type_aide) == -1) {
            errors.type_aide ="Le type est invalide";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = {
                id: formData.id,
                libelle: formData.libelle,
                type_aide: formData.type_aide,
            };
            await axios.post(`/backoffice/categories-aides/save`, formToUpload);
            router.push('/app/categories-aides/list');
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }
</script>

<template>
    <section class="container-full-1 bg-grey-50">
        <div class="page-space-30"></div>

        <section class="s20_mobile px-4">
            <div class="widget px-7 py-7">
                <h4 class="font-semibold mb-5">Catégories Aides / Edition <span class="text-sm text-grey-500"></span></h4>

                <div class="form-field-floating active my-4">
                    <select class="form-input-select" name="type_aide" id="type_aide" v-model="formData.type_aide">
                        <option value="FAQ" selected>FAQ</option>
                        <option value="TUTORIEL" selected>Tutoriel</option>
                    </select>
                    <label for="categorie">Type <b class="color-danger">*</b></label>
                </div>
                <span v-if="!!errors['type_aide']" class="text-red">{{ errors['type_aide'] }}</span>

                <div class="form-field-floating reactive active my-4">
                    <input type="text" class="form-input" v-model="formData.libelle" name="libelle" id="libelle" placeholder="">
                    <label for="libelle">Libellé <b class="color-danger">*</b></label>
                </div>
                <span v-if="!!errors['libelle']" class="text-red">{{ errors['libelle'] }}</span>

                <div class="clear-both h-30"></div>
                <span v-if="!!errorMessage" class="text-red">{{ errorMessage }}</span>
                <p class="text-text-xs text-grey-500 mb-5"><b class="color-danger text-xs">*</b> Les champs marqués d'un astérisque sont obligatoires</p>
                <div class="flex gap-2">
                    <custom-button id="btn-submit" type="button" :classesList="'btn lg w-100'" :loading="loading" @click="onSubmit()">
                        <img src="/icons/icon-enregistrer.svg" class="btn-icon" alt="" />
                        <span>Enregistrer</span>
                    </custom-button>
                    <button class="btn stroke black lg">
                        <span>Effacer</span>
                    </button>
                </div>
                
            </div>
        </section>
        
    </section>
</template>
